import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import some from 'lodash/some'
import orderBy from 'lodash/orderBy'
import uniqBy from 'lodash/uniqBy'

import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import { Checkbox  } from 'primereact/checkbox';
import { Card } from 'primereact/card';


import { getPermissionCatalog } from '@actions/profiles'
import { SET_VALUES_PROFILE } from '@constants/actionType'
import { 
  PERMISSION_SECCION,
  PERMISSION_USER,
  PERMISSION_DOCUMENTS,
  PERMISSION_REPORTS,
  PERMISSION_INTEREST,
  PERMISSION_PROCESS,
  PERMISSION_ADMINISTRATION,
  PERMISSION_DIGITAL_FORM
} from '@constants/general'
import catalogPermissionsId from '@constants/catalogPermissionsId'

import store from '@store';

import './style.scss'

const PERMISSIONS_HIDDEN = [19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,42,46,47,52]

class PermissionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissionList: [],
      permissionSelect: [],
      errors: []
    };
    this.rulesPermissions = [
      {
        id: catalogPermissionsId.SUSPENDER_ACTIVAR_USUARIO_INTERNO,
        parentId: catalogPermissionsId.VER_USUARIOS_INTERNOS
      },
      {
        id: catalogPermissionsId.CARGA_MASIVA_DE_USUARIOS_INTERNOS,
        parentId: catalogPermissionsId.VER_USUARIOS_INTERNOS
      },
      {
        id: catalogPermissionsId.ACCESO_DETALLE_REPORTES,
        parentId: catalogPermissionsId.ACCESO_REPORTES
      }
    ]
  }

  async componentDidMount() {
    const { _profileSelect, isFullAdmin } = this.props;
    await this.setPermissionCatalog()

    if (_profileSelect) {
      this.setState({ permissionSelect: _profileSelect });
    }
    if (!isFullAdmin) {
      PERMISSIONS_HIDDEN.push(catalogPermissionsId.ADMINISTRAR_EVALUADORES)
      PERMISSIONS_HIDDEN.push(catalogPermissionsId.ADMINISTRAR_GESTORES)
      PERMISSIONS_HIDDEN.push(catalogPermissionsId.ADMINISTRAR_COORDINADORES)
      PERMISSIONS_HIDDEN.push(catalogPermissionsId.ADMINISTRAR_ROLES)
    }
    this.setState({ loadingPage: false });
  }

  setPermissionCatalog = async () => {
    const { getPermissionCatalog, permissionCatalog } = this.props
    if (!permissionCatalog.length) {
      const response = await getPermissionCatalog()
      if (!response?.status) {
        await store.dispatch({
          type: SET_VALUES_PROFILE,
          payload: {
            permissionCatalog: response.data
          }
        });
        this.setState({ permissionList: response.data })
      }
    } else {
      this.setState({ permissionList: permissionCatalog })
    }
  }
  

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeCheck = (e) => {
    const { permissionSelect } = this.state
    let profileSelectVisible = [...permissionSelect];
    if(e.checked) {
      profileSelectVisible.push(e.value);
    } else {
      profileSelectVisible.splice(profileSelectVisible.indexOf(e.value), 1);
    }
    profileSelectVisible = this.validateRulesPermissions(e.value, e.checked, profileSelectVisible)

    this.setState(
      {permissionSelect: profileSelectVisible},
      () => this.validateFieldsOnchange(`permissionSelect`, true)
    );
  }

  validateRulesPermissions = (idCheked, isCheked, profilesSelected ) => {

    if (isCheked) {
      const isPermissionIntoRulesChild = this.rulesPermissions.find(item => item.id === idCheked)
      if (isPermissionIntoRulesChild) {
        const isSelectedParentPermission = profilesSelected.find(item => item === isPermissionIntoRulesChild.parentId)
        if (!isSelectedParentPermission) {
          profilesSelected.push(isPermissionIntoRulesChild.parentId)
          return profilesSelected
        }
      }
    } else {
      const isPermissionIntoRulesParent = this.rulesPermissions.filter(item => item.parentId === idCheked)
      if (isPermissionIntoRulesParent.length) {
        isPermissionIntoRulesParent.map(item => {
          profilesSelected = profilesSelected.filter(permission => permission !== item.id)
        })
        return profilesSelected || []
      }
    }
    return profilesSelected
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { permissionSelect } = this.state
    let errors = {}
    if (!permissionSelect.length ) errors = { ...errors, [`permissionSelect`]: 'permissionSelect es requerido' }
    this.setState({errors})
    return errors
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { success } = this.props
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    await this.setValuesToStateGlobal();
    success()
  };

  setValuesToStateGlobal = async () => {
    const { permissionSelect } = this.state;


    await store.dispatch({
      type: SET_VALUES_PROFILE,
      payload: {
        permissionSelect
      }
    });
    return true
  };

  checkedBySection = (type) => {
    const { t } = this.props
    const { permissionSelect, permissionList } = this.state

    const getDetailPermissionSelect = permissionSelect.reduce((accum, permissionId) => {
      const validate = permissionList.find(item => item.id === permissionId && item.seccion === type)
      if (validate) accum.push(validate)
      return accum
    }, [])
    return getDetailPermissionSelect.length ? `(${getDetailPermissionSelect.length} ${t('seleccionados')})` : ''
  }
  

  render() {
    const { t, btnSubmitLoading, onBack  } = this.props;

    const {
      loadingPage,
      errors,
      permissionSelect,
      permissionList
    } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);

    const renderProfilesOption = (data) => data.map(item => (
      <div className="p-field-checkbox" key={item.nombre}>
        <Checkbox
          inputId={`cb${item.id}`}
          name="permissionSelect"
          value={item.id}
          onChange={this.onChangeCheck}
          checked={permissionSelect.indexOf(item.id) !== -1}
          className={classNames({
            'p-invalid': isFormFieldValid(`permissionSelect`),
          })}
        />
        <label >{item.nombre}</label>
      </div>
    ))

    const renderCardsByGroup = (type, typeClass) => {
      const header = (
        <div className="header-card p-p-2 p-text-bold">
          <h5>{type} {this.checkedBySection(type)}</h5>
        </div>
      )

      let filterDataBySection = permissionList.filter(item => item.seccion === type)
      if (filterDataBySection.length) {
        filterDataBySection = filterDataBySection.filter(item => PERMISSIONS_HIDDEN.indexOf(item.id) === -1 ) // Oculta permisos no tomados en cuenta
        filterDataBySection = orderBy(filterDataBySection, ['grupo', 'orden'])
        const uniqueGroup = uniqBy(filterDataBySection, 'grupo').map(item => item.grupo)
        const group = uniqueGroup.map(item => filterDataBySection.filter(opt => opt.grupo === item))


        return (
          <Card header={header} className={`p-my-4 ${typeClass || ''}`}>
            { group.map((data, index) => (
                <div key={`item-${type}-${index}`}>
                  { renderProfilesOption(data) }
                  { (index) !== (group.length - 1 ) && (
                    <Divider className="p-py-2"/>
                  ) }
                </div>
              ))}
          </Card>
        )
      }
    }

    if (loadingPage) return true;

    return (
      <form onSubmit={this.onSubmit} autoComplete="false">
        <div className="p-fluid p-grid p-mb-4">
          <div className="p-col-4 p-field">
            {renderCardsByGroup(PERMISSION_SECCION, 'card-primary')}
            {renderCardsByGroup(PERMISSION_DIGITAL_FORM, 'card-primary')}
            {renderCardsByGroup(PERMISSION_USER, 'card-secondary')}
          </div>
          <div className="p-col-4 p-field">
            {renderCardsByGroup(PERMISSION_DOCUMENTS, 'card-primary')}
            {renderCardsByGroup(PERMISSION_REPORTS, 'card-secondary')}
            {/* {renderCardsByGroup(PERMISSION_INTEREST, 'card-secondary')} */}
            {renderCardsByGroup(PERMISSION_PROCESS, 'card-secondary')}
          </div>
          <div className="p-col-4 p-field">
            {renderCardsByGroup(PERMISSION_ADMINISTRATION, 'card-simple')}
          </div>
        </div>
        <div className="p-col-12 footer-btn">
          <div className="p-d-flex p-jc-between">
            <Button
              label={t('Regresar')}
              type="button"
              className="p-button-secondary"
              onClick={() => onBack()}
            />
             <Button
             label={t('Continuar')}
             type="submit"
             className="p-button-primary"
             loading={btnSubmitLoading}
           />
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state) => ({
  _profileSelect: state.profile.permissionSelect,
  profilesCurrentCatalog: state.catalogs.profilesCurrentCatalog,
  permissionCatalog: state.profile.permissionCatalog,
  isFullAdmin: state.settings.isFullAdmin,
});

const mapDispatchToProps = {
  getPermissionCatalog
};


export default withRouter(compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(PermissionForm));
